import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    entireSequence: string;
    exporting: (name: string) => string | React.ReactNode;
    noSequence: string;
    uploadLocationDisabledTooltip: string;
    sequenceInOut: string;
    viewProgress: string;
    untitled: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for entire sequence export range option */
            entireSequence: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SequenceExport.entireSequence?c=3czz2y6g3eqrx", defaultMessage: "Entire Sequence" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message displayed when exporting a sequence */
            exporting: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string) => __intl__.intl().formatMessage({ id: "SequenceExport.exporting?c=303p2ed1gz23v", defaultMessage: "Exporting {name}" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** Form validation error message when no active sequence is present */
            noSequence: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SequenceExport.noSequence?c=r3q2kgbjra97", defaultMessage: "No active sequence" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip text when "Add to Version Stack" is disabled */
            uploadLocationDisabledTooltip: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SequenceExport.uploadLocationDisabledTooltip?c=1e8nheyg5sbg6", defaultMessage: "Disable \"Add to Version Stack\" to change location." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the sequence export range option */
            sequenceInOut: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SequenceExport.sequenceInOut?c=239vkgpnbuot", defaultMessage: "Sequence In / Out" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to view export progress */
            viewProgress: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SequenceExport.viewProgress?c=3e7drdjn7vg6j", defaultMessage: "View Progress" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Default value for the asset name field when exporting a sequence */
            untitled: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SequenceExport.untitled?c=1c7211k9mphpb", defaultMessage: "Untitled" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
